<script>
import { getParentNodes } from '@utils/dom'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    dropdownTop: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      lang_menu: false,
    }
  },
  computed: {
    ...mapState(['common']),
    dropdownStyle() {
      if (this.dropdownTop !== null) {
        return {
          top:
            typeof this.dropdownTop === 'number'
              ? `${this.dropdownTop}px`
              : this.dropdownTop,
        }
      }
      return {}
    },
  },
  beforeMount() {
    document.body.addEventListener('click', this.onBodyClick)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.onBodyClick)
  },
  methods: {
    ...mapActions('common', ['SetLocale']),
    onBodyClick(e) {
      const parentNodes = getParentNodes(e.target)
      const chk1 = e.target !== this.$refs.type_lang
      const chk2 = !~parentNodes.indexOf(this.$refs.type_lang)
      if (chk1 && chk2) this.lang_menu = false
    },
    localeChange(locale) {
      this.$i18n.locale = locale
      this.SetLocale(locale)
    },
    flagSelect(locale) {
      if (this.common.locales[locale] === 'English') {
        return 'en'
      } else if (this.common.locales[locale] === '한국어') {
        return 'ko'
      } else if (this.common.locales[locale] === '日本語') {
        return 'ja'
      } else if (this.common.locales[locale] === '中文(中国)') {
        return 'cn'
      } else if (this.common.locales[locale] === '中文(臺灣)') {
        return 'tw'
      } else if (this.common.locales[locale] === 'Français') {
        return 'fr'
      } else if (this.common.locales[locale] === 'Deutsch') {
        return 'de'
      } else if (this.common.locales[locale] === 'Español') {
        return 'es'
      } else if (this.common.locales[locale] === 'Tiếng Việt') {
        return 'vi'
      } else if (this.common.locales[locale] === 'Português') {
        return 'pt'
      }
    },
    toggleMenu() {
      this.lang_menu = !this.lang_menu
    },
  },
}
</script>

<template>
  <div class="lang-wrap">
    <div
      ref="type_lang"
      :class="{ active: lang_menu === true }"
      class="lang"
      @click="toggleMenu"
    >
      <div class="lang-left">
        <span class="title-img" :class="`${flagSelect(common.locale)}`"></span>
        <span class="title-locale">{{ common.locales[common.locale] }}</span>
      </div>
      <img
        src="@assets/images/v2/icon/icon-arrow-down-black.svg"
        alt=""
        class="icon"
      />
    </div>
    <!-- 언어 선택 -->
    <ul v-if="lang_menu" class="lang-dropbox" :style="dropdownStyle">
      <li
        v-for="(name, locale) in common.locales"
        :key="name"
        :class="{ active: common.locale === locale }"
        @click="localeChange(locale)"
      >
        <span class="nation-img" :class="`${flagSelect(locale)}`"></span>
        <span class="nation-tit">{{ name }}</span>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>

<style scoped>
.lang-wrap {
  position: relative;
}
.lang {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px;
  cursor: pointer;
  background: #fff;
  border: 0.8px solid #f0f0f0;
  border-radius: 8px;
}

.lang-left {
  display: flex;
  align-items: center;
}

.lang .title-img {
  width: 14px;
  height: 14px;
  margin-right: 3px;
  background-repeat: no-repeat;
  background-size: 100%;
}
.lang span {
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
}
.lang .icon {
  width: 12px;
  height: 12px;
  margin-left: 12px;
}

.lang:hover {
  text-decoration: none;
}

.lang .gnb-svg {
  float: right;
  width: 10px;
  padding: 4px;
  transition: 0.3s;
}

.lang.active .gnb-svg {
  transform: rotate(180deg);
}

.lang-dropbox {
  position: absolute;
  z-index: 9;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
}

.lang-dropbox li {
  position: relative;
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
}

.lang-dropbox li.active {
  color: #333;
  background-color: #dfeaf7;
}

.lang-dropbox li.active span {
  color: #333;
}

.lang-dropbox .nation-tit {
  line-height: 40px;
}

.lang-dropbox .nation-img {
  display: inline-block;
  width: 16px;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-position: 0;
  background-size: 100%;
}

@media (max-width: 768px) {
  .lang {
    padding: 5px 10px;
  }
  .lang span {
    font-size: 10px;
  }
  .lang .title-img {
    width: 10px;
    height: 10px;
  }
  .lang .icon {
    width: 10px;
    height: 10px;
  }
}
</style>
